import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ccb710a2")

_pushScopeId("data-v-ccb710a2")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "icon icon-heart-ico" }, [
  /*#__PURE__*/_createVNode("span", { class: "path1 text-22" }),
  /*#__PURE__*/_createVNode("span", { class: "path2 text-22" })
], -1)
const _hoisted_2 = { class: "hidden md:block text-white text-base lg:text-lg leading-5 lg:leading-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon icon-heart-ico text-htz-red text-32 pr-3" }, [
  /*#__PURE__*/_createVNode("span", { class: "path1 text-32" }),
  /*#__PURE__*/_createVNode("span", { class: "path2 text-32" })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "fav-text uppercase text-htz-red text-13 font-livory-bold hover:text-htz-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isEntityValid)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        (!_ctx.inline)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", {
                class: ["card-icon lg:opacity-0 h-30 w-30 absolute z-10 left-0 right-auto flex items-center justify-center rounded-full border-white border-2 bg-white transition-all duration-300 cursor-pointer m-2 hover:border-htz-red", {'heart-active': (_ctx.isFavorite || _ctx.isHover)}],
                onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHover = true)),
                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isHover = false)),
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleMe()), ["prevent"]))
              }, [
                _hoisted_1
              ], 34),
              _createVNode("div", {
                class: ["card-fav-overlay absolute h-0 max-h-0 left-0 right-0 top-0 w-full flex flex-col justify-center space-y-4 pt-8 lg:pt-10 pb-4 lg:pb-6 px-4 lg:px-6 bg-black bg-opacity-75 opacity-0 overflow-hidden transition-all duration-300 ease-in-out", {'opacity-100 z-50 h-full max-h-full overflow-visible': _ctx.showOverlay === true}]
              }, [
                (_ctx.showOverlay ===true)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("loc_really_remove")) + " " + _toDisplayString(_ctx.$filters.getPropertyValue(  _ctx.$t, "Title", _ctx.entity)) + " ? ", 1),
                      _createVNode("button", {
                        class: "btn-red min-w-200",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.removeMe()), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("loc_remove")), 1),
                      _createVNode("button", {
                        class: "btn-transparent-blue  min-w-200",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.cancelMe()), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("loc_cancel")), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ], 64))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: ["add-to-fav-container flex items-center transition-all duration-300 cursor-pointer mt-2 lg:m-2", {'heart-active': (_ctx.isFavorite)}],
              onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isHover = true)),
              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isHover = false)),
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.toggleMe()), ["prevent"]))
            }, [
              _hoisted_3,
              (_ctx.isFavorite)
                ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("loc_added_to_wishlist")), 1))
                : (_openBlock(), _createBlock("span", {
                    key: 1,
                    class: ["fav-text uppercase text-htz-darkgrey text-13 font-livory-bold hover:text-htz-red", {'text-htz-red': _ctx.isHover}]
                  }, _toDisplayString(_ctx.$t("loc_add_to_wishlist")), 3))
            ], 34))
      ], 64))
    : _createCommentVNode("", true)
})